// @flow

import * as React from 'react';

type Props = {
  width?: string,
  height?: string,
  color?: string,
};

export const Checkmark = ({ width, height, color }: Props) => (
  <svg
    viewBox="0 0 20 20"
    width={width || '100%'}
    height={height || '100%'}
    style={{ fill: color || 'currentColor' }}
  >
    <path d="M7.41 18.053c-.27 0-.528-.108-.717-.302l-6.41-6.577c-.384-.395-.376-1.03.02-1.414.396-.387 1.027-.378 1.414.018l5.603 5.75L18.208 1.39c.335-.438.965-.52 1.403-.182.438.337.52.965.182 1.403L8.202 17.664c-.178.23-.445.37-.735.388l-.058.003" />
  </svg>
);
